import { render, staticRenderFns } from "./QuickbuyVerificationsList.vue?vue&type=template&id=7c4638b0&scoped=true&"
import script from "./QuickbuyVerificationsList.vue?vue&type=script&lang=js&"
export * from "./QuickbuyVerificationsList.vue?vue&type=script&lang=js&"
import style0 from "./QuickbuyVerificationsList.vue?vue&type=style&index=0&id=7c4638b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4638b0",
  null
  
)

export default component.exports